module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/first","commonjs2":"rxjs/add/operator/first","amd":"rxjs/add/operator/first"}
// module id = 15
// module chunks = 0 1